/**
 * @file product-form-constants.ts
 *
 * Shared limits and accepted types for the product form's media. Kept in one
 * place so the media hook, the drop zone, and the media section agree on the
 * same caps (matching the Website Builder v2 reference: 10 images, 10 MB per
 * file).
 */

/** Maximum file size for product media uploads, in megabytes. */
export const MAX_MEDIA_FILE_SIZE_MB = 10;

/** Maximum number of gallery images allowed per product. */
export const MAX_PRODUCT_MEDIA_IMAGES = 10;

/** Image MIME types accepted by the gallery drop zone. */
export const ACCEPTED_IMAGE_TYPES = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/webp',
  'image/gif',
];

/**
 * Client-side ceilings on the variation matrix, matching the commerce-engine caps. Enforced
 * live in the form so an obviously over-budget matrix is caught before the save round-trip
 * (`4 axes × 4 values = 256` is legal per field but rejected at save without this).
 */
export const MAX_VARIANT_OPTIONS = 6;
export const MAX_VALUES_PER_OPTION = 50;
export const MAX_VARIANT_COMBINATIONS = 100;
